// extracted by mini-css-extract-plugin
export var container = "_88-0";
export var error = "_88-9";
export var label = "_88-5";
export var light = "_88-6";
export var md = "_88-3";
export var sm = "_88-2";
export var thin = "_88-8";
export var thinBold = "_88-7";
export var vertical = "_88-4";
export var xs = "_88-1";